export default __webpack_public_path__ + "static/media/BYD_E2_01.2b15f297.jpg";